// the opposite of a noscript tag
document.querySelectorAll('.show-on-js').forEach((v)=>{
    v.classList.remove('hidden');
    v.classList.remove('show-on-js');
});

//# sourceMappingURL=show-on-js.b913ded3.js.map
